import { render, staticRenderFns } from "./kpigl.vue?vue&type=template&id=c2446b6a&scoped=true"
import script from "./kpigl.vue?vue&type=script&lang=js"
export * from "./kpigl.vue?vue&type=script&lang=js"
import style0 from "./kpigl.vue?vue&type=style&index=0&id=c2446b6a&prod&lang=css&scoped=true"
import style1 from "./kpigl.vue?vue&type=style&index=1&id=c2446b6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2446b6a",
  null
  
)

export default component.exports